import type { RecentLoanListing } from 'app/network/loan';
import React from 'react';
import { RecentLoanCard } from './recent-loan-card';

export function RecentExchangeCard({ listing }: { listing: RecentLoanListing }) {
  return <RecentLoanCard listing={listing} variant="exchange" />;
}
